import React from "react";

const AvailabilityPageSkeleton = () => {
  return (
    <div className="px-4 sm:px-6 lg:px-8">
      <div className="animate-pulse">
        {/* Header section */}
        <div className="sm:flex sm:items-center">
          <div className="sm:flex-auto">
            <div className="h-4 bg-cream-300 rounded w-3/4 mb-2"></div>
          </div>
          <div className="mt-4 sm:ml-16 sm:mt-0 sm:flex-none">
            <div className="h-10 bg-cream-300 rounded w-40"></div>
          </div>
        </div>

        {/* Table sections skeleton */}
        <div className="mt-8">
          <div className="mb-8">
            <div className="h-6 bg-cream-300 rounded w-48 mb-1"></div>
            <div className="h-4 bg-cream-300 rounded w-96 mb-4"></div>
            {/* Mobile cards */}
            <div className="sm:hidden space-y-4">
              {[1, 2].map((i) => (
                <div
                  key={i}
                  className="bg-white rounded-lg border border-ink-100 p-4"
                >
                  <div className="flex items-start justify-between">
                    <div className="flex-1 min-w-0">
                      <div className="h-4 bg-cream-300 rounded w-3/4"></div>
                    </div>
                    <div className="ml-4">
                      <div className="size-5 bg-cream-300 rounded"></div>
                    </div>
                  </div>
                  <div className="mt-4 space-y-3">
                    <div className="flex items-start">
                      <div className="w-16 h-3 bg-cream-300 rounded"></div>
                      <div className="ml-2 flex-1">
                        <div className="h-3 bg-cream-300 rounded w-3/4"></div>
                      </div>
                    </div>
                    <div className="flex items-start">
                      <div className="w-16 h-3 bg-cream-300 rounded"></div>
                      <div className="ml-2 flex-1">
                        <div className="h-3 bg-cream-300 rounded w-1/2"></div>
                      </div>
                    </div>
                    <div className="flex items-center">
                      <div className="w-16 h-3 bg-cream-300 rounded"></div>
                      <div className="ml-2 h-6 bg-cream-300 rounded w-20"></div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            {/* Desktop table */}
            <div className="hidden sm:block">
              <div className="overflow-visible shadow ring-1 ring-black/5 sm:rounded-lg">
                <div className="bg-cream-100 px-4 py-3.5 sm:px-6">
                  <div className="grid grid-cols-5 gap-4">
                    <div className="h-4 bg-cream-300 rounded"></div>
                    <div className="h-4 bg-cream-300 rounded"></div>
                    <div className="h-4 bg-cream-300 rounded"></div>
                    <div className="h-4 bg-cream-300 rounded"></div>
                    <div className="h-4 bg-cream-300 rounded"></div>
                  </div>
                </div>
                <div className="bg-white divide-y divide-ink-100">
                  {[1, 2].map((i) => (
                    <div key={i} className="px-4 py-4 sm:px-6">
                      <div className="grid grid-cols-5 gap-4 items-center">
                        <div className="h-4 bg-cream-300 rounded w-32"></div>
                        <div className="h-3 bg-cream-300 rounded w-24"></div>
                        <div className="h-3 bg-cream-300 rounded w-40"></div>
                        <div className="h-3 bg-cream-300 rounded w-32"></div>
                        <div className="h-6 bg-cream-300 rounded w-20"></div>
                        <div className="flex justify-end">
                          <div className="size-5 bg-cream-300 rounded"></div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AvailabilityPageSkeleton;
